import React from "react";
import { Document, Page, Text, View, Image } from "@react-pdf/renderer";
import moment from "moment";

import style from "./style";
import PdfSummaryItem from "../PdfSummaryItem";

function PreviewPdf(props) {
  return (
    <Document>
      <Page size="A4" style={style.page}>
        <View style={style.container}>
          <View style={style.pictureContainer}>
            <Text style={style.timestamp}>
              Date: {moment().format("MM/DD/YYYY")}
            </Text>
            <Image
              style={{ width: 80, height: 80 }}
              src={props.picture}
            />
          </View>
          <View style={style.contentContainer}>
            {props.data.map((item, index) => {
              return (
                <PdfSummaryItem
                  sno={(index + 1).toString()}
                  question={item.label}
                  answer={item.value}
                />
              );
            })}
            {/* {new Array(100).fill(0).map((_, index) => (
              <PdfSummaryItem
                sno={(index + 1).toString()}
                question="What is your name"
                answer="Izaan jahangir"
              />
            ))} */}
          </View>
        </View>
      </Page>
      <Page size="A4" style={style.page}>
        <Image
          style={{ width: 80, height: 80 }}
          src={props.picture}
        />
        <View>
          <Text style={{ marginBottom: 30, marginTop: 30, fontSize: 12 }}>
            {props.name.firstName} {props.name.middleName} {props.name.lastName}
          </Text>
          <Text style={{ fontSize: 12 }}>
            I hereby certify that the information provided in this form is
            correct.
          </Text>
          <Text style={{ fontSize: 12, marginTop: 15, marginBottom: 15 }}>
            I further consent and authorize the National Identity Management
            Commision to release my NIN information (as may be required) to the
            National Pension Commision (PenCom), upon request by my Pension Fund
            Administrator, for the maintenance and operation of my Retirement
            Savings Account
          </Text>
          <Text style={{ marginBottom: 30, fontSize: 12 }}>
            It is my understanding that PenCom shall exercise due care to ensure
            that my information is secure and protected.
          </Text>
        </View>
        <Image style={{ width: 120 }} src={props.signature} alt="signature" />
      </Page>
    </Document>
  );
}

PreviewPdf.defaultProps = {
  data: [],
};

export default PreviewPdf;
